import { useCallback, useContext } from 'react'

import { TokenPickerRevampContext } from '@/components/base/TokenPickerRevamp/context'
import { WrappedTokensFlowContext } from '@/components/base/WrappedTokensFlow/context'
import { CustomTokenInfo } from '@/utils/helpers'

import TopTokensList from '../TopTokensList'

const Container = () => {
  const { setSelectedToken } = useContext(WrappedTokensFlowContext)
  const { setIsOpenPicker } = useContext(TokenPickerRevampContext)

  const onClickToken = useCallback((token: CustomTokenInfo) => {
    setIsOpenPicker(false)
    setSelectedToken(token)
  }, [setIsOpenPicker, setSelectedToken])

  return <TopTokensList onClickToken={onClickToken} />
}

export default Container
